export const HomePage = () => {
  document.title = 'Trang chủ - iMES System';
  return <div></div>;
};
